import { BOTTOM_NAV } from './BottomNav'
import { BUTTONS_MYINFO } from './MyInfo'




//  角色
var ROLES = {
  administrators: {
    name: 'administrators',
    title: '系统管理员',
    bottomNavs: [
      BOTTOM_NAV.work,
      BOTTOM_NAV.message,
      BOTTOM_NAV.document,
      BOTTOM_NAV.myinfo
    ],
    buttonMyInfo: [
    ]
  },
  users: {
    name: 'users',
    title: '用户',
    bottomNavs: [
      BOTTOM_NAV.work,
      BOTTOM_NAV.message,
      BOTTOM_NAV.document,
      BOTTOM_NAV.myinfo
    ],
    buttonMyInfo: [
    ]
  },
  others: {
    name: '',
    title: '为空',
    bottomNavs: [
      BOTTOM_NAV.message,
      BOTTOM_NAV.document,
      BOTTOM_NAV.myinfo
    ],
    buttonMyInfo: [
    ]
  }
}

export { ROLES }
